export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_06.35a54f11.jpg";